import { render, staticRenderFns } from "./TasksExport.vue?vue&type=template&id=0df01c38"
import script from "./TasksExport.vue?vue&type=script&lang=js"
export * from "./TasksExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports